export default "__VITE_ASSET__DXQuLfHB__"